import React, {ForwardedRef, InputHTMLAttributes, useId, useState} from "react";
import classNames from "classnames";
import './CustomSVVTextinput.scss'

import {SVVLabel} from "@komponentkassen/svv-form";
import {SVVFormError} from "@komponentkassen/svv-form";

type TextInputProps = {
    label: string;
    errorMessage?: string;
    inputSize?: "xsmall" | "small" | "medium" | "large";
    id: string;
    required?: boolean;
    countryCode: string;
    helpText:string;
} & InputHTMLAttributes<HTMLInputElement>;

function CustomSVVTextInput(
    {
        errorMessage,
        label,
        placeholder,
        inputSize = "medium",
        id,
        required,
        type = "text",
        countryCode,
        helpText,
        ...rest
    }: TextInputProps,
    ref: ForwardedRef<HTMLInputElement>,
) {
    const [errorMessageId] = useState(`feilmelding-${useId()}`);
    const hasErrorMessage = !!errorMessage;
    return (
        <div className={"svv-form-element svv-form-element--margin-bottom svv-form-element--max-width"}>
            {label && (
                <SVVLabel htmlFor={id} required={required}>
                    {label}
                </SVVLabel>
            )}
            <p className="svv-form-description">
              {helpText}
            </p>
            <div className="mobile-input-wrapper">
                <input
                    className={classNames("country-code", "svv-form-input__text", "input--large",  {
                        "country-code__text--error": hasErrorMessage
                    })}
                    value={countryCode}
                    disabled
                    readOnly
                    type={type}
                ></input>
                <input
                    id={id}
                    className={classNames("mobile-input", "svv-form-input__text", {
                        "svv-form-input__text--error": hasErrorMessage,
                        "input--x-small": inputSize === "xsmall",
                        "input--small": inputSize === "small",
                        "input--medium": inputSize === "medium",
                        "input--large": inputSize === "large",
                    })}
                    placeholder={placeholder}
                    aria-invalid={hasErrorMessage}
                    aria-describedby={hasErrorMessage ? errorMessageId : undefined}
                    required={required}
                    type={type}
                    {...rest}
                />
            </div>

            <div aria-live="assertive">
                {errorMessage && (
                    <SVVFormError id={errorMessageId}>
                        <p>{errorMessage}</p>
                    </SVVFormError>
                )}
            </div>
        </div>
    );
}

export default CustomSVVTextInput;